import React from 'react';
import './Card.css';

export type CardVariant = 'feature' | 'service' | 'value' | 'help' | 'process';

interface CardProps {
  variant?: CardVariant;
  icon?: React.ReactNode;
  image?: string;
  imageAlt?: string;
  title: string;
  description: string;
  children?: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({
  variant = 'feature',
  icon,
  image,
  imageAlt,
  title,
  description,
  children,
  className = ''
}) => {
  // Check if icon is an image path (string starting with /)
  const isIconImage = typeof icon === 'string' && icon.startsWith('/');

  return (
    <div className={`card card-${variant} ${className}`}>
      {image && (
        <img src={image} alt={imageAlt || title} className="card-image" />
      )}
      {icon && (
        <div className="card-icon">
          {isIconImage ? (
            <img src={icon} alt={`${title} icon`} className="card-icon-image" />
          ) : (
            icon
          )}
        </div>
      )}
      <h3 className="card-title">{title}</h3>
      <p className="card-description">{description}</p>
      {children}
    </div>
  );
};

export default Card;
